module.exports = __webpack_public_path__ + "Roboto-Regular.8fa8a82f0969cd7d7027.woff2";


//////////////////
// WEBPACK FOOTER
// D:/V1/er.web.candidateconsole/src/assets/fonts/Roboto-Regular.woff2
// module id = ../../../../../src/assets/fonts/Roboto-Regular.woff2
// module chunks = styles